/*
 * @Author: Ning
 * @Date: ****** 13:23:08
 * @LastEditTime: 2020-09-09 14:38:05
 * @LastEditors: Ning
 * @Description: System Logs 日志
 * @Do not edit
 */
const initialState = {
    userInfo :{}
};
const userLoginInfo = (state = initialState ,action) => {
    switch (action.type){
        case "SAVE_LOGIN" :{
            return action.userInfo;
        }
        default:
            return state;
    }
}
export default userLoginInfo;
